import { StaticPagesItemViewModel, StaticPagesViewModel } from '@api/index';
import { StaticPageSchemaOrg } from '@utils/schemaorg/StaticPageSchemaOrg';

import { InfoCard } from './InfoCard';
import BasePage from './BasePage';
import { Image } from '../setur/styled';

type StaticPageProps = React.PropsWithChildren<
  Partial<StaticPagesViewModel> & {
    renderCustomItems?: (items: StaticPagesItemViewModel[]) => React.ReactNode;
  }
>;
const StaticPage = ({
  children,
  name,
  metaTitle,
  metaDescription,
  images = [],
  items = [],
  renderCustomItems,
}: StaticPageProps) => {
  return (
    <BasePage title={name}>
      {metaTitle && metaDescription ? (
        <StaticPageSchemaOrg name={metaTitle} description={metaDescription} />
      ) : null}
      {images?.map((img, index) => (
        <Image
          style={{ borderRadius: '8px' }}
          key={index}
          src={img?.url}
          alt={img?.alt}
          fill
        />
      ))}
      {renderCustomItems?.(items) ||
        items?.map((item, index) => <InfoCard key={index} {...item} />)}
      {children}
    </BasePage>
  );
};

export default StaticPage;
